function normalizeSearchValue(rawValue) {
    return rawValue.trim();
}
function normalizeSelectValue(rawValue) {
    return rawValue.trim();
}
function debounce(callback, delay) {
    let timeoutId;
    return (...args) => {
        if (timeoutId !== undefined) {
            window.clearTimeout(timeoutId);
        }
        timeoutId = window.setTimeout(() => {
            callback(...args);
        }, delay);
    };
}

export { debounce, normalizeSearchValue, normalizeSelectValue };
